export default {
    setDownloadFilesArr(state, payload){
        console.log("payloadpayloadpayloadpayloadpayloadpayload",payload)
        // if(state.filesToBeDownloaded.length){
        //     state.filesToBeDownloaded = state.filesToBeDownloaded.concat(payload);
        // }else{
            // if(!state.filesToBeDownloaded[payload.key]){
            //     state.filesToBeDownloaded = {};
            // }
            if(!state.filesToBeDownloaded[payload.key]){
                state.filesToBeDownloaded[payload.key] = {};
            }
            state.filesToBeDownloaded[payload.key] = payload.value;
            state.currentBatch.key = payload.key;
            state.currentBatch.value = payload.value;
            // state.downloadArray.push({key:payload.key,value:[...payload.value]});
            state.lastDownloadBatchID = payload.key
        // }
    },
    removeFileFromDownloadQueue(state,payload){
        console.log("statestate",state,payload)
        // state.filesToBeDownloaded = state.filesToBeDownloaded.filter(e => e._id != payload._id);
    },
    cancelDownloadMultipleFiles(state){
        console.log("statestate",state)
        // state.filesToBeDownloaded = {};
        // state.downloadArray = [];
    },
    setCompletedStatus(state,payload){
        if(state.filesToBeDownloaded[payload.key]){
            let findVal = state.filesToBeDownloaded[payload.key].find(e => e._id == payload.index)
            if(findVal){
                findVal["completed"] = true;
            }
        }
        
    },
    unsetDownloadArray(state){
        state.downloadArray = [];
    },
   
    unsetCurrentBatchList(state){
        state.currentBatch.value = [];
    },

    unsetCurrentBatchKey(state){
        state.currentBatch.key = '';
    },

    unsetFilesTobBeDownloaded(state){
        state.filesToBeDownloaded = {};
    }
};